<template>
  <container>
    <div class="service-unavailable-page w-100 p-0 m-0">
      <h1>Service Unavailable</h1>
    </div>
  </container>
</template>
<script>
/**
 * ==================================================================================
 * Service Unavailable page
 * ==================================================================================
 **/

import MainLayout from '@/layouts/MainLayout'

export default {
  metaInfo: function() {
    return {
      title: 'Service unavailable'
    }
  },
  components: {
    container: MainLayout
  }
}
</script>
<style lang="scss" scoped>
.main-layout {
  height: 100%;
}

.service-unavailable-page {
  display: flex;
  height: 80%;
  justify-content: center;
  align-items: center;

  h1 {
    text-align: center;
  }
}
</style>
